import styled, { css } from "styled-components/native";
import { black, mid_blue, silver, spacing_l, spacing_m, spacing_s, spacing_xs, white, white_smoke } from "../../StyleHelpers";
import { ChannelButtonProps, ContainerProps, LoaderProps, Props, StyledProps } from "./model";
import { direction, Pages } from "../../Types";

//#region Index Components Style
export const StyledContainer = styled.View<ContainerProps>`
	padding: ${(props: ContainerProps) => (props.isNarrow ? "80px" : "124px")} 0 0 0;
	z-index: -1;
`;

export const StyledContainerWithMargin = styled.View`
	margin: 0 112px;
	padding: 124px 0 0 0;
	z-index: -1;
`;
//#endregion

//#region Screen Manager Style
export const StyledParentContainer = styled.View`
	height: 100%;
`;

export const StyledMainContainer = styled.View<Props>`
	height: 100%;
	padding-bottom: 10%;
	z-index: -2;

	${(props) =>
		!props.addMarginLeft &&
		css`
			margin-left: ${spacing_l};
		`}

	${(props) =>
		props.addMarginLeft &&
		css`
			margin-left: 92px;
			margin-right: 51px;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			padding-left: 0;
			margin-left: 0;
			margin-right: 0;
			padding-right: 24px;
			padding-bottom: 0;
			height: calc(100vh - 80px);
		`}
`;

export const StyledCard = styled.View<any>`
	width: 100%;
	padding: 0 ${spacing_l} ${spacing_l} 0;

	${(props) =>
		props.isNarrow &&
		css`
			padding: 0 ${spacing_m} ${spacing_m} 0;
		`}
`;

export const StyledMargin = styled.View`
	margin: 0 ${spacing_l} 0 0;
`;

export const StyledNoDevices = styled.View`
	margin: 63px 0 10% 20px;
`;
export const StyledWithDevices = styled.View`
	margin: 0px 0 10% 0px;
`;

export const StyledContentContainer = styled.View<any>`
	${(props) =>
		props.wheelPosition === "right" &&
		css`
			margin: 0 120px 0 30px;
		`}

	${(props) =>
		props.wheelPosition !== "right" &&
		css`
			margin: 0 30px 0 0;
		`}

	${(props) =>
		props.addMarginLeft &&
		css`
			padding-right: 51px;
		`}
`;

export const StyledContentContainerNarrow = styled.View<any>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	align-self: stretch;
`;

export const StyledText = styled.View<StyledProps>`
	height: 100%;
	flex-direction: row;
	align-items: center;

	${(props) =>
		props.wheelPosition !== "right" &&
		css`
			justify-content: space-between;
		`}

	${(props) =>
		props.wheelPosition === "right" &&
		css`
			justify-content: start;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			flex: 1 0 0;
			align-self: stretch;
		`}
`;

export const StyledTextContainer = styled.View<any>`
	height: 75px;

	${(props) =>
		props.isSync &&
		css`
			justify-content: center;
			align-items: center;
		`}

	${(props) =>
		props.location !== Pages.assignScreen &&
		props.wheelPosition !== "right" &&
		css`
			margin-left: 145px;
		`}

	${(props) =>
		props.location !== Pages.assignScreen &&
		props.wheelPosition === "right" &&
		css`
			margin-left: 0px;
			padding-left: 0px;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			margin-left: 0px;
			padding-left: 0px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: flex-start;
			flex: 1 0 0;
			align-self: stretch;
		`}
`;

export const StyledController = styled.View<any>`
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	${(props) =>
		props.isAssignToScreen &&
		props.isPlayButton &&
		css`
			display: flex;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			display: flex;
		`}
`;

export const StyledImage = styled.View<any>`
	flex-direction: row;
	justify-content: center;
	align-items: center;
	width: 100%;
	gap: 0.625rem;
	padding: 0 1rem;

	${(props) =>
		props.isAssignToScreen &&
		props.isPlayButton &&
		css`
			justify-content: start;
			gap: 0.5rem;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			justify-content: start;
			gap: 0.5rem;
		`}
`;

export const StyledButtonText = styled.Text<any>`
	font-size: 23px;
	margin-left: -3px;

	${(props) =>
		props.isNarrow &&
		css`
			margin-left: 0;
			color: #f2f2f2;
			font-family: Nunito;
			font-size: 21px;
			font-style: normal;
			font-weight: 500;
			line-height: 25px;
		`}
`;

export const StyledOtherDevicesHeader = styled.Text`
	color: ${white_smoke};
	font-size: 30px;
`;

export const StyledOtherDevicesBody = styled.Text`
	color: ${white_smoke};
	font-size: 25px;
	opacity: 0.5;
`;

export const StyledControllerText = styled.Text<any>`
	color: white;
	font-size: 25px;

	${(props) =>
		props.direction &&
		css`
			text-align: center;
			width: 100%;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			display: flex;
			flex-direction: column;
			justify-content: center;
			flex: 1 0 0;
			align-self: stretch;
			color: #f2f2f2;
			text-align: center;
			font-size: 21px;
			font-style: normal;
			font-weight: 400;
			line-height: 25px;
		`}

	${(props) =>
		!props.isNarrow &&
		props.isRHD &&
		css`
			margin-left: 24px;
		`}
`;

export const StyledEmptySpace = styled.View`
	width: 11.45vh;
	height: 100%;
	margin-right: 20px;
`;

export const StyledControllerContainer = styled.View<any>`
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	${(props) =>
		props.isNarrow &&
		css`
			flex-direction: column;
			align-items: center;
			gap: 10px;
			flex: 1 0 0;
			align-self: stretch;
			border-radius: 12px;
			background: #0a1d39;
		`}
`;

export const StyledLoading = styled.View<Props>`
	border-radius: 16px;
	overflow: hidden;
	z-index: -1;

	${(props) =>
		props.addMarginLeft &&
		css`
			margin: ${spacing_l} 0 0 0;
			width: 98.4%;
			height: 194px;
		`}
	${(props) =>
		!props.addMarginLeft &&
		css`
			margin: ${spacing_l} 0 0 0;
			width: 98.4%;
			height: 194px;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			margin: ${spacing_l} 0 0 0;
			width: 98.4%;
			height: 194px;
		`}
`;

export const StyledSync = styled.View<any>`
	display: flex;
	width: 100%;

	${(props) =>
		props.wheelPosition !== "right" &&
		css`
			flex-direction: row;
			margin-left: 147px;
		`}

	${(props) =>
		props.wheelPosition === "right" &&
		css`
			flex-direction: row-reverse;
			margin-left: 0;
			padding-right: 30px;
		`}
`;

export const StyledSyncBody = styled.View`
	justify-content: center;
`;

export const StyledCancelContainer = styled.View`
	width: 172px;
`;

export const StyledAddScreenContainer = styled.View<any>`
	width: 210px;

	${(props) =>
		props.isNarrow &&
		css`
			width: 100%;
		`}
`;

export const StyledCancelButton = styled.View<any>`
	${(props) =>
		(props.redirectTo === direction.player || props.redirectTo === "main-player") &&
		css`
			margin-right: 120px;
		`}

	width: 14.02vw;
`;

export const StyledControllerButton = styled.View<any>`
	${(props) =>
		props.location !== Pages.assignScreen &&
		css`
			margin-left: 145px;
		`}

	${(props) =>
		props.location === Pages.assignScreen &&
		css`
			margin-left: 110px;
		`}
	display: flex;
	flex-direction: row;

	${(props) =>
		props.isNarrow &&
		css`
			margin-left: 0;
			flex-direction: column;
			width: 268px;
			gap: 10px;
		`}
`;

export const StyledOtherDevicesContainer = styled.View`
	margin-top: 20px;
`;

export const StyledOtherDevicesLoader = styled.View<LoaderProps>`
	overflow: hidden;
	width: ${(props) => props.width}px;
	height: ${(props) => props.height}px;

	${(props) =>
		props.marginBottomLarge &&
		css`
			border-radius: 12px;
			margin-bottom: ${spacing_m};
		`}
	${(props) =>
		!props.marginBottomLarge &&
		css`
			border-radius: 8px;
			margin-bottom: ${spacing_xs};
		`}
`;

export const StyledRightTextContainer = styled.View<any>`
	${(props) =>
		props.assignScreen !== Pages.assignScreen &&
		css`
			display: flex;
			flex-direction: row-reverse;
			padding-right: 230px;
			width: 100%;
		`}

	${(props) =>
		props.syncRibbon &&
		css`
			display: flex;
			flex-direction: row;
			justify-content: center;
			padding-left: 230px;
		`}
		
	${(props) =>
		props.direction &&
		css`
			justify-content: center;
			padding: 0px 0px 0px 205px;
		`}
`;
//#endregion

//#region Channel Button style
export const StyledMain = styled.View<ChannelButtonProps>`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 194px;
	justify-content: space-between;
	align-items: center;
	border-radius: 8px;
	background-color: ${(props) => (props.noDevice ? "transparent" : "black")};
	overflow: hidden;
	${(props) =>
		props.isLoader &&
		css`
			background: ${silver};
			opacity: 0.2;
		`}
	${(props) =>
		props.isNarrow &&
		css`
			width: 369px;
			height: 134px;
			border-radius: 4px;
		`}
`;

export const StyledHover = styled.View<any>`
	width: 100%;
	position: absolute;
	height: 194px;
	z-index: 999;
	border-radius: 8px;
	border-color: 1px solid rgba(90, 90, 90, 0.5);
	border-width: 1px;
	border-color: 0.6s ease;

	${(props) =>
		props.selected &&
		css`
			display: block;
			border-color: ${mid_blue};
			border-width: 2px;
			background-image: linear-gradient(90deg, rgba(35, 98, 190, 0.5) 0%, rgba(35, 98, 190, 0) 100%);
		`}

	${(props) =>
		props.isHovered &&
		css`
			display: block;
			border-color: ${white};
			border-width: 2px;
		`}

	${(props) =>
		props.noDevice &&
		css`
			display: block;
			border-color: transparent;
			border-width: 2px;
			background: transparent;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			height: 134px;
			border-radius: 4px;
		`}
`;

export const StyledInfo = styled.View<any>`
	display: flex;
	width: 408px;
	height: 194px;
	max-width: 408px;
	padding: ${spacing_m};
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 28px;
	flex-shrink: 0;

	${(props) =>
		props.isNarrow &&
		css`
			width: 250px;
			height: 134px;
			padding: ${spacing_s};
			gap: ${spacing_s};
		`}
`;

export const StyledIcon = styled.View<any>`
	height: 100%;
	justify-content: center;

	${(props) =>
		!props.isNarrow &&
		css`
			width: 100%;
		`}
`;

export const StyledProgressBar = styled.View`
	width: 100%;
`;

export const StyledHeader = styled.View`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	align-self: stretch;
`;

export const StyledHeaderText = styled.Text<any>`
	color: white;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;

	${(props) =>
		props.isNarrow &&
		css`
			font-size: 14px;
			line-height: 16px;
		`}
`;

export const StyledAction = styled.Text<any>`
	color: white;
	font-size: 18px;
	opacity: 0.6;

	${(props) =>
		props.isNarrow &&
		css`
			font-size: 14px;
			line-height: 16px;
		`}
`;

export const StyledTBGContainer = styled.View<any>`
	position: absolute;
	display: flex;
	width: 100%;
	height: 194px;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-end;

	${(props) =>
		props.isNarrow &&
		css`
			width: 369px;
			height: 134px;
		`}
`;

export const StyledTBG = styled.View<ChannelButtonProps>`
	width: 388px;
	height: 194px;
	border-radius: 8px;
	${(props) =>
		props.isTBG &&
		props.bgImage &&
		css`
			background-image: url(${props.bgImage});
			background-repeat: no-repeat;
			background-size: cover;
			background-color: lightgray;
			background-position: 50% /;
		`}

	${(props) =>
		!props.bgImage &&
		css`
			background-color: #333333;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			border-radius: 4px;
			width: 369px;
			height: 134px;
		`}
`;

export const StyledTBGGradient = styled.View<any>`
	z-index: 1;
	height: 194px;
	width: 194px;
	flex-shrink: 0;
	background-image: linear-gradient(90deg, ${black} 0%, rgba(0, 0, 0, 0) 100%);

	${(props) =>
		props.isNarrow &&
		css`
			width: 369px;
			height: 134px;
			border-radius: 4px;
		`}
`;

export const StyledStatus = styled.View<any>`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;
	align-self: stretch;

	${(props) =>
		props.isNarrow &&
		css`
			gap: 2px;
		`}
`;

export const StyledPackshot = styled.View<any>`
	display: flex;
	width: 140px;
	height: 194px;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;

	${(props) =>
		props.isNarrow &&
		css`
			width: 100px;
			height: 134px;
		`}
`;

export const StyledPackshotImage = styled.View<ChannelButtonProps>`
	display: flex;
	width: 108px;
	height: 162px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	border-radius: 8px;
	${(props) =>
		props.bgImage &&
		css`
			background-image: url(${props.bgImage});
			background-repeat: no-repeat;
			background-size: cover;
			background-color: lightgray;
			background-position: 50% /;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			border-radius: 4px;
			width: 100px;
			height: 134px;
		`}
`;

export const StyledNarrowRibbon = styled.View<any>`
	display: flex;
	flex-direction: column;
	justify-content: ${(props) => (props.isCentered ? "center" : "flex-start")};
	align-items: center;
	gap: 24px;
	flex: 1 0 0;
	align-self: stretch;
	border-radius: 12px;
`;

export const StyledCloseButton = styled.TouchableOpacity`
	position: absolute;
	right: -25px;
	top: calc(50% - 15px);
	background: #0a1d39;
	border-radius: 100%;
	border: 5px;
	cursor: pointer;
	border-color: transparent;
`;

export const StyledNarrowDividerContainer = styled.View`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: 32px;
`;

export const StyledScreenContainerNarrowView = styled.View`
	margin-top: 24px;
	border: 0;
`;

//#endregion
